export * from './lib/text';
